import type { HTMLAttributes } from 'react';
import { cn } from './cn';

const variants = {
  default: 'bg-stitch-surface-2 text-stitch-fg border border-stitch-border',
  primary: 'bg-stitch-primary-soft text-stitch-primary dark:text-stitch-primary',
  success: 'bg-stitch-success-soft text-stitch-success dark:text-stitch-success',
  warning: 'bg-stitch-warning-soft text-stitch-warning dark:text-stitch-warning',
  danger: 'bg-stitch-danger-soft text-stitch-danger dark:text-stitch-danger',
  accent: 'bg-stitch-accent-soft text-stitch-accent dark:text-stitch-accent',
} as const;

export interface BadgeProps extends HTMLAttributes<HTMLSpanElement> {
  variant?: keyof typeof variants;
}

export function Badge({ className, variant = 'default', ...props }: BadgeProps) {
  return (
    <span
      className={cn(
        'inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium',
        variants[variant],
        className,
      )}
      {...props}
    />
  );
}
